__turbopack_context__.v({
  "blurredNotificationImg": "Vcc_CW_blurredNotificationImg",
  "btnLink": "Vcc_CW_btnLink",
  "buttons": "Vcc_CW_buttons",
  "container": "Vcc_CW_container",
  "content": "Vcc_CW_content",
  "img": "Vcc_CW_img",
  "linkArrow": "Vcc_CW_linkArrow",
  "subContainer": "Vcc_CW_subContainer",
  "title": "Vcc_CW_title",
});
